let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4i9aQ")).then(() => parcelRequire('hIWLF'));